/* All Music browser: in-page filters, search, stock toggle and sort for
   sections/release-browser.liquid. Filters within a group are OR, across groups AND.
   Groups with an order list only show (and only accept from the URL) the values
   named there; plain "Digital" is left out of Format on purpose (Digital Only stays).
   Leaner set (Oct 2026):
   - Special Editions combines the old Edition and Collector Finds groups (from
     each release's data-edition + data-finds), without Original Release, Last
     Few Copies (that one is the Almost Gone browse link; cards still show the
     "Last few copies" badge) or Limited Edition (it only matched "limited" in
     variant names, which were inconsistent from the Bandcamp import).
   - Release Type leaves out Album (nearly everything is one).
   - Release Year is four ranges instead of one chip per year.
   - Artist can be folded with +/- and starts open. */
(function () {
  var RANGES = [
    { label: '2025–26', min: 2025, max: 9999 },
    { label: '2022–24', min: 2022, max: 2024 },
    { label: '2018–21', min: 2018, max: 2021 },
    { label: '2014–17', min: 0, max: 2017 }
  ];
  var GROUPS = [
    { key: 'format', label: 'Format', order: ['Vinyl LP', 'CD', 'Cassette', '7-inch', 'Flexi Disc', 'Digital Only'] },
    { key: 'special', label: 'Special Editions', order: ['Color Vinyl', 'OBI Strip Edition', 'Test Pressing', 'IA11 Edition', 'Limited Reissue'] },
    { key: 'type', label: 'Release Type', order: ['EP / Single', 'Live Recording', 'Mixtape / Remixes'] },
    { key: 'year', label: 'Release Year', pills: true, order: RANGES.map(function (r) { return r.label; }) },
    { key: 'artist', label: 'Artist', find: true, top: 8, fold: true }
  ];
  var STYLE = '.rb__group--fold{border:0;padding:0;margin:0}' +
    '.rb__group--fold>summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between}' +
    '.rb__group--fold>summary::-webkit-details-marker{display:none}' +
    '.rb__group--fold>summary::after{content:"+";font-size:1.6rem;line-height:1;opacity:.6}' +
    '.rb__group--fold[open]>summary::after{content:"\\2212"}';
  function init(root) {
    var grid = root.querySelector('[data-rb-grid]');
    if (!grid) return;
    if (!document.getElementById('rb-fold-style')) {
      var st = document.createElement('style'); st.id = 'rb-fold-style'; st.textContent = STYLE; document.head.appendChild(st);
    }
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-rb-item]'));
    var groupsEl = root.querySelector('[data-rb-groups]');
    var sel = {}, showAll = false, find = '', foldOpen = true;
    var cache = {};
    var raw = function (li, key) {
      if (key === 'special') return (li.getAttribute('data-edition') || '') + '|' + (li.getAttribute('data-finds') || '');
      if (key === 'year') {
        var y = parseInt(li.getAttribute('data-year'), 10);
        if (!y) return '';
        for (var i = 0; i < RANGES.length; i++) if (y >= RANGES[i].min && y <= RANGES[i].max) return RANGES[i].label;
        return '';
      }
      return li.getAttribute('data-' + key) || '';
    };
    var vals = function (li, key) {
      var id = key + (li.__rbId || (li.__rbId = Math.random()));
      if (cache[id]) return cache[id];
      var out = [];
      raw(li, key).split('|').forEach(function (v) { v = v.trim(); if (v && out.indexOf(v) < 0) out.push(v); });
      return (cache[id] = out);
    };
    var params = new URLSearchParams(location.search);
    GROUPS.forEach(function (g) {
      var p = params.get(g.key);
      sel[g.key] = p ? p.split(',').filter(function (v) { return !g.order || g.order.indexOf(v) > -1; }) : [];
    });

    items.forEach(function (li) {
      var info = li.querySelector('.card-information') || li.querySelector('.card__content');
      Array.prototype.slice.call(li.children).forEach(function (el) {
        if (info && (el.classList.contains('rb__date') || el.classList.contains('rb__badge'))) info.appendChild(el);
      });
      if (li.hasAttribute('data-b')) li.querySelectorAll('.card__heading a').forEach(function (a) {
        if (a.querySelector('em')) return;
        a.textContent = '';
        a.appendChild(document.createTextNode(li.getAttribute('data-a')));
        a.appendChild(document.createElement('br'));
        var em = document.createElement('em'); em.textContent = li.getAttribute('data-b'); a.appendChild(em);
      });
    });

    var allCounts = {};
    GROUPS.forEach(function (g) {
      var c = {};
      items.forEach(function (li) { vals(li, g.key).forEach(function (v) { c[v] = (c[v] || 0) + 1; }); });
      allCounts[g.key] = c;
    });
    function optionList(g) {
      var c = allCounts[g.key], keys = Object.keys(c);
      if (g.order) return g.order.filter(function (k) { return c[k]; });
      if (g.pills) return keys.sort().reverse();
      return keys.sort(function (a, b) { return a.localeCompare(b); });
    }

    function buildGroups() {
      groupsEl.textContent = '';
      GROUPS.forEach(function (g) {
        var opts = optionList(g);
        if (!opts.length) return;
        var fs, lg;
        if (g.fold) {
          fs = document.createElement('details'); fs.className = 'rb__group rb__group--fold';
          fs.open = foldOpen || !!find || sel[g.key].length > 0;
          fs.addEventListener('toggle', function () { foldOpen = fs.open; });
          lg = document.createElement('summary'); lg.className = 'rb__legend';
          lg.textContent = g.label + (sel[g.key].length ? ' (' + sel[g.key].length + ')' : '');
        } else {
          fs = document.createElement('fieldset'); fs.className = 'rb__group';
          lg = document.createElement('legend'); lg.className = 'rb__legend'; lg.textContent = g.label;
        }
        fs.appendChild(lg);
        if (g.pills) {
          var wrap = document.createElement('div'); wrap.className = 'rb__years';
          opts.forEach(function (o) {
            var b = document.createElement('button'); b.type = 'button'; b.className = 'rb__year'; b.textContent = o;
            b.setAttribute('aria-pressed', String(sel[g.key].indexOf(o) > -1));
            b.addEventListener('click', function () { toggle(g.key, o); });
            wrap.appendChild(b);
          });
          fs.appendChild(wrap);
        } else {
          var list = opts;
          if (g.find) {
            var f = document.createElement('input'); f.type = 'search'; f.className = 'rb__find'; f.placeholder = 'Find an artist'; f.setAttribute('aria-label', 'Find an artist'); f.value = find;
            f.addEventListener('input', function () { find = f.value; buildGroups(); var nf = groupsEl.querySelector('.rb__find'); if (nf) { nf.focus(); nf.setSelectionRange(nf.value.length, nf.value.length); } });
            fs.appendChild(f);
            var needle = find.toLowerCase();
            if (needle) list = opts.filter(function (o) { return o.toLowerCase().indexOf(needle) > -1; });
            else if (!showAll) {
              var top = opts.slice().sort(function (a, b) { return allCounts[g.key][b] - allCounts[g.key][a]; }).slice(0, g.top);
              list = opts.filter(function (o) { return top.indexOf(o) > -1 || sel[g.key].indexOf(o) > -1; });
            }
          }
          list.forEach(function (o) {
            var lab = document.createElement('label'); lab.className = 'rb__opt';
            var cb = document.createElement('input'); cb.type = 'checkbox'; cb.checked = sel[g.key].indexOf(o) > -1;
            cb.addEventListener('change', function () { toggle(g.key, o); });
            var name = document.createElement('span'); name.textContent = o;
            var n = document.createElement('span'); n.className = 'rb__opt-count'; n.textContent = allCounts[g.key][o];
            lab.appendChild(cb); lab.appendChild(name); lab.appendChild(n); fs.appendChild(lab);
          });
          if (g.find && !find && opts.length > g.top) {
            var more = document.createElement('button'); more.type = 'button'; more.className = 'rb__more';
            more.textContent = showAll ? 'Show fewer artists' : 'Show all ' + opts.length + ' artists';
            more.addEventListener('click', function () { showAll = !showAll; buildGroups(); });
            fs.appendChild(more);
          }
        }
        groupsEl.appendChild(fs);
      });
    }
    function toggle(key, v) {
      var i = sel[key].indexOf(v);
      if (i > -1) sel[key].splice(i, 1); else sel[key].push(v);
      buildGroups(); apply();
    }

    var search = root.querySelector('[data-rb-search]'), stock = root.querySelector('[data-rb-stock]'), sort = root.querySelector('[data-rb-sort]');
    if (params.get('q') && search) search.value = params.get('q');
    if (params.get('stock') === '1' && stock) stock.checked = true;
    if (params.get('sort') && sort) sort.value = params.get('sort');
    var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };

    function apply() {
      var terms = norm(search ? search.value.trim() : '').split(/\s+/).filter(Boolean);
      var physical = stock && stock.checked, shown = 0, active = 0;
      GROUPS.forEach(function (g) { active += sel[g.key].length; });
      items.forEach(function (li) {
        var ok = true;
        GROUPS.forEach(function (g) {
          if (!ok || !sel[g.key].length) return;
          var have = vals(li, g.key);
          ok = sel[g.key].some(function (v) { return have.indexOf(v) > -1; });
        });
        if (ok && physical && li.getAttribute('data-physical') !== '1') ok = false;
        if (ok && terms.length) { var hay = norm(li.getAttribute('data-search')); ok = terms.every(function (t) { return hay.indexOf(t) > -1; }); }
        li.hidden = !ok;
        if (ok) shown++;
      });
      root.querySelector('[data-rb-count]').textContent = shown === items.length ? items.length + ' releases' : shown + ' of ' + items.length + ' releases';
      root.querySelector('[data-rb-empty]').hidden = shown !== 0;
      root.querySelector('[data-rb-active-count]').textContent = active ? '(' + active + ')' : '';
      var chips = root.querySelector('[data-rb-chips]'); chips.textContent = '';
      GROUPS.forEach(function (g) { sel[g.key].forEach(function (v) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'rb__chip'; b.textContent = v;
        b.setAttribute('aria-label', 'Remove filter ' + v);
        b.addEventListener('click', function () { toggle(g.key, v); });
        chips.appendChild(b);
      }); });
      root.querySelector('[data-rb-clear]').hidden = !active;
      var p = new URLSearchParams(location.search);
      ['edition', 'finds'].forEach(function (k) { p.delete(k); });
      GROUPS.forEach(function (g) { if (sel[g.key].length) p.set(g.key, sel[g.key].join(',')); else p.delete(g.key); });
      if (search && search.value.trim()) p.set('q', search.value.trim()); else p.delete('q');
      if (physical) p.set('stock', '1'); else p.delete('stock');
      if (sort && sort.value !== 'new') p.set('sort', sort.value); else p.delete('sort');
      var qs = p.toString();
      try { history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
    }
    function doSort() {
      var how = sort ? sort.value : 'new';
      var num = function (li, a) { return parseInt(li.getAttribute(a), 10) || 0; };
      items.slice().sort(function (a, b) {
        if (how === 'old') return num(a, 'data-date') - num(b, 'data-date');
        if (how === 'price') return num(a, 'data-price') - num(b, 'data-price');
        if (how === 'price-desc') return num(b, 'data-price') - num(a, 'data-price');
        if (how === 'artist') return (a.getAttribute('data-sortname') || '').localeCompare(b.getAttribute('data-sortname') || '');
        if (how === 'deep') return (num(b, 'data-deep') - num(a, 'data-deep')) || (num(a, 'data-date') - num(b, 'data-date'));
        return num(b, 'data-date') - num(a, 'data-date');
      }).forEach(function (li) { grid.appendChild(li); });
    }
    var clearAll = function () { GROUPS.forEach(function (g) { sel[g.key] = []; }); if (search) search.value = ''; if (stock) stock.checked = false; buildGroups(); apply(); };
    root.querySelector('[data-rb-clear]').addEventListener('click', clearAll);
    root.querySelector('[data-rb-clear-2]').addEventListener('click', clearAll);
    if (search) { search.addEventListener('input', apply); search.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); }); }
    if (stock) stock.addEventListener('change', apply);
    if (sort) sort.addEventListener('change', function () { doSort(); apply(); });
    var details = root.querySelector('[data-rb-filters]');
    if (details && window.matchMedia('(max-width: 989px)').matches) details.open = false;
    buildGroups(); doSort(); apply();
  }
  function boot() { document.querySelectorAll('[data-rb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
